/**
 * The space types' icons (data/presets.ts SPACE_TYPES `icon` names), the one
 * map every page draws them from. A new icon: import it here and name it in
 * the list.
 */

import { Bath, Building2, Car, ChefHat, Hammer, Home, LayoutGrid, WashingMachine, Warehouse } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const SPACE_ICONS: Record<string, LucideIcon> = { Car, Home, Building2, WashingMachine, Hammer, Warehouse, Bath, ChefHat, LayoutGrid };

/** The icon of that name, or the generic grid. */
export const spaceIcon = (name: string | undefined): LucideIcon => (name && SPACE_ICONS[name]) || LayoutGrid;
